import { render, staticRenderFns } from "./SalesNews.vue?vue&type=template&id=6cc12afa"
import script from "./SalesNews.vue?vue&type=script&lang=js"
export * from "./SalesNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports